export const productImagePlaceholder = `data:image/png;base64,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`

export function unbindOriginalSearch(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
        var newElement = el.cloneNode(true);
        el.parentNode.replaceChild(newElement, el);
    })
}

export const fallbackColorsForSwatches = {
    '#000000' : '#000000',
    '#0000FF' : '#0000FF',
    '#FF0000' : '#FF0000',
    '18K Gold':'#D4AF37',
    '64-67 Rampart Red':'',
    '68 Caravelle Metallic Blue':'',
    '69-72 AMC Engine Metallic Blue':'',
    '73-81 AMC Engine Blue':'',
    '9mm Metallic':'',
    'AMC Blue Metallic':'',
    'Allis Chalmers Orange':'',
    'Aluminum':'',
    'Amber':'#FFBF00' ,
    'Amber + White':'#FFE5B4',
    'Amber Halo':'',
    'Amber/White':'',
    'Amber/White Switchback':'',
    'Antique White':'#FAEBD7',
    'Aqua':'#00FFFF',
    'Arctic Shawl (4886)':'',
    'Arctic Shawl (5000AS)':'',
    'Arctic White': '#F0F8FF',
    'Artic White':'#F0F8FF',
    'Ash':'#B2BEB5',
    'Austin Healey Moss Green Metallic':'',
    'Basil' : '#789262',
    'Bay Point (4796)':'',
    'Bay Point (5000BP)':'',
    'Beige': '#F5F5DC',
    'Bitchin Black':'',
    'Black':'#000000',
    'Black & Blue':'',
    'Black (Gloss)':'#000000',
    'Black (Satin)':'#000000',
    'Black Cherry': '#3B0B0B',
    'Black Marl':'#414141',
    'Black Plum':'#4D0135',
    'Black Sapphire':'',
    'Black-T':'',
    'Black/Black':'#000000',
    'Black/Red':'#FF0000',
    'Blackout':'#000000',
    'Blaze':'#FF7F50',
    'Blaze Orange':'#FF6700',
    'Blue':'#0000FF',
    'Blue By You':'',
    'Blue Halo':'#87CEEB',
    'Blue Mayhem':'#0D3B66',
    'Blue Steel':'#4682B4',
    'Blue and Amber':'',
    'Blue and Red':'',
    'Brown': '#A52A2A',
    'Brown Camo': '#7B3F00',
    'Brown Marl': '#804000',
    'Brown [S]Color':'#A52A2A',
    'Bue':'',
    'Buff/Tan': '#F0DC82',
    'Buick Green Late':'',
    'Buick Red':'',
    'Buick Red Late':'',
    'Buick Turquoise':'',
    'Burnt Orange':'#CC5500',
    'Cadillac Dark Blue':'',
    'Camo':'#104624',
    'Camo Black':'',
    'Camo Green':'#41533B',
    'Camo Tan':'',
    'Camouflage':'#A1865C',
    'Candy Pants Violet':'',
    'Caravelle Blue Metallic':'',
    'Carbon (Black)':'#0C0A00',
    'Carbon Balck':'#0C0A00',
    'Carbon Black':'#0C0A00',
    'Carbon White':'',
    'Caribbean Bay Blue Pearl':'',
    'Caribe Blue':'#0DAAB5',
    'Cascade Teal':'#A2CCC5',
    'Case Power Tan':'',
    'Cast Iron Grey':'',
    'Cat Yellow':'',
    'Cat Yellow (Gloss)':'',
    'Cedar Green':'#ABA389',
    'Champagne Metallic': '#F7E7CE',
    'Charcoal': '#36454F',
    'Charcoal Gray': '#36454F',
    'Charcoal Grey 80/20 (4170)':'#666666',
    'Charcoal Metallic': '#2F4F4F',
    'Chevrolet Blue':'',
    'Chevy Dark Charcoal':'',
    'Chevy Grey':'',
    'Chevy Orange':'',
    'Chop Top Silver Metallic':'',
    'Chrome':'#DBE2E9',
    'Chrysler Blue':'',
    'Chrysler Turquoise':'',
    'Cinnamon Red': '#7B3F00',
    'Classic Deere Green':'',
    'Classic Red':'#FF0000',
    'Clay': '#B66A50',
    'Clear':'',
    'Clear - Flat':'',
    'Clear - High Gloss':'',
    'Clear - Satin':'',
    'Coastal Highway Blue':'',
    'Cobalt':'#0047AB',
    'Cobalt Blue':'#0047AB',
    'Cobolt':'#346DB1',
    'Coffee/Carbon Black':'#0B0B0B',
    'ColorSHIFT®':'',
    'ColorSHIFT® - 2.0':'',
    'ColorSHIFT® - BC1':'',
    'ColorSHIFT® - Dynamic':'',
    'ColorSHIFT® - No Controller':'',
    'ColorSHIFT® - RF':'',
    'ColorSHIFT® - Simple':'',
    'ColorSHIFT® - w/ 2.0 Controller':'',
    'ColorSHIFT® - w/ BC1 Controller':'',
    'ColorSHIFT® - w/ No Controller':'',
    'ColorSHIFT® - w/ RF Controller':'',
    'ColorSHIFT® - w/ Simple Controller':'',
    'ColorSHIFT® - w/2.0 Controller':'',
    'ColorSHIFT® - w/BC1 Controller':'',
    'ColorSHIFT® - w/No Controller':'',
    'ColorSHIFT® - w/RF Controller':'',
    'ColorSHIFT® - w/Simple Controller':'',
    'ColorSHIFT® 2.0':'',
    'ColorSHIFT® RGB+A':'',
    'ColorSHIFT® w/ 2.0 Controller':'',
    'ColorSHIFT® w/ BC1 Controller':'',
    'ColorSHIFT® w/ No Controller':'',
    'ColorSHIFT® w/ RF Controller':'',
    'ColorSHIFT® w/ Simple Controller':'',
    'Cool White':'#F4FDFF',
    'Copper':'#B87333',
    'Coronet Blue':'#7995B9',
    'Coyote':'',
    'Coyote Brown':'#9D764C',
    'Craft Armor':'',
    'Craft Crisp White':'',
    'Craft Midnight Black':'',
    'Cranberry':'#8B0000',
    'Crazy Plum':'',
    'Cream':'#FFFDD0',
    'Crimson Point':'#DC143C',
    'Crimson Point (4885)':'#C60C30',
    'Cruise Night Blue':'',
    'Cummins Beige':'',
    'Cyan Blue':'#92C6E2',
    'Dark Blue':'#00008B',
    'Dark Brown':'#5C4033',
    'Dark Gray':'#5A5A5A',
    'Dark Green':'#006400',
    'Dark Grey':'#A9A9A9',
    'Dark Navy':'#000080',
    'Daytona Yellow':'',
    'Deep Blue':'#00008B',
    'Desert Tan':'#EDC9AF',
    'Desert Tan Camo':'',
    'Destroyer Gray':'#A9A9A9',
    'Detroit Diesel Apline Green':'',
    'Dream Season (4888)':'',
    'Dream Season (5000DS)':'',
    'Electric Yellow': '#FFFF33',
    'Engine Blue':'#003366',
    'Equipment New Yellow':'',
    'Equipment Old Yellow':'',
    'Euro Racing Green':'',
    'Eye Candy Green':'',
    'Fire Red':'#B22222',
    'Fireball Red Pearl':'',
    'Flame Blue':'#007BA7',
    'Flat Black':'#070707',
    'Flat Black Camo':'',
    'Flat White':'#EDEDED',
    'Fluorescent Green':'#39FF14',
    'Fluorescent Green-Black':'#39FF14',
    'Fluorescent Orange':'#FF5F1F',
    'Ford Blue':'',
    'Ford Blue 1966 80':'',
    'Ford Corporate Blue':'',
    'Ford Dark Blue':'',
    'Ford Green':'',
    'Forest':'',
    'Forest Green':'',
    'Forest State (4887)':'',
    'Forest-Orange':'',
    'Forest/Orange':'',
    'Frost Blue':'#E0FFFF',
    'GLOW':'#FFC223',
    'GM Corporate Blue':'',
    'GM Fleet White':'',
    'GM White':'',
    'Galv Steel':'',
    'Galvanized (Matte)':'',
    'Galvanized Steel':'#A9A9A9',
    'Gasser White':'',
    'Glacier':'#6F8D95',
    'Glacier Blue':'#72A0C1',
    'Gloss':'',
    'Gloss Aerosol':'',
    'Gloss Black':'#110011',
    'Gloss Finish':'',
    'Gloss Red':'',
    'Gloss White':'#FFFDFA',
    'Gray':'#808080',
    'Gray Granite':'',
    'Green':'#008000',
    'Green Camo':'',
    'Green Halo':'#008000',
    'Green/Black':'',
    'Grey':'#808080',
    'Grey (Gloss)':'#808080',
    'Grey 50/50 (4488)':'#808080',
    'Grey/Black':'#808080',
    'Grey/White':'',
    'GunMetal Gray':'#2C2C2C',
    'Heather Grey':'#525657',
    'Hemi Orange':'',
    'Heritage Black':'#000000',
    'Heritage Purple':'#6A0DAD',
    'Hi-Vis':'#C8D114',
    'Hi-Visibility Green':'',
    'High Gloss Black':'',
    'High Gloss Finish':'',
    'High Gloss Jet Black':'',
    'Hot Rod Black':'',
    'Hot Rod Red':'#C1272D',
    'Hugger Orange':'#FF8C00',
    'IHC Red':'',
    'Infra Red':'',
    'Irish Green':'#009A44',
    'Iron Oxide Red':'',
    "Italian Officer's Reproduction (4088)":'',
    'Ivory':'#FFFFF0',
    'Jaded Green Metallic':'',
    'Jet Black':'#343434',
    'John Deere Ag Yellow':'',
    'John Deere Green':'',
    'John Deere Industrial Yellow':'',
    'LIMITED EDITION - Pumpkin Spice (5003)':'',
    'Lava Red':'#FF0000',
    'Lichen Green':'#9CB4AC',
    'Lift Truck Blue':'',
    'Lift Truck Orange':'',
    'Light Blue':'#ADD8E6',
    'Light Brown Marl':'#C4A484',
    'Light Gray':'#D3D3D3',
    'Light Grey':'#D3D3D3',
    'Light Grey Primer':'#D3D3D3',
    'Light Sand':'#D0BFA9',
    'Lime Green':'#32CD32',
    'MG Green':'',
    'MG Maroon':'#800000',
    'Machine Gray':'#636362',
    'Magenta':'#FF00FF',
    'Malibu Sunset':'',
    'Maroon Red':'#852B3E',
    'Maroon Rose Metallic':'#800020',
    'Matte Black':'#1C1C1C',
    'Matte Finish':'',
    'Matte Red':'',
    'Meadow Green':'#85B174',
    'Medium Grey':'',
    'Meteor Gray Metallic':'#6E6E6E',
    'Mint':'#98FF98',
    'Mist':'#E9ECEC',
    'Mocha Granite':'',
    'Molten Red Metallic':'#8B2500',
    'Moon Mist Grey':'#D1D0CE',
    'Moss':'#8A9A5B',
    'Mossy Oak Bottomland':'',
    'Mossy Oak Break Up Country':'',
    'Mossy Oak DNA':'',
    'Mulsanne Blue Metallic':'#0F52BA',
    'Multi-Camo':'',
    'Mustard Yellow':'#E1AD01',
    'Natural (no pigment added)':'',
    'Navy':'#000080',
    'Navy Marl':'#6888A3',
    'New Deere Green':'',
    'New Deere Yellow':'',
    'No HALO':'',
    'OD Green':'#6B6E5F',
    'OD Green_S':'#4E5D31',
    'Ocean':'#53737E',
    'Off White':'#FAF9F6',
    'Off-White':'#F8F8FF',
    'Off-White (Gloss)':'',
    'Old Cummins Gold':'',
    'Old Ford Blue':'',
    'Olds Bronze':'',
    'Olds Gold':'',
    'Olive':'#808000',
    'Olive Drab Green':'',
    'Olive Green':'#AA9F70',
    'Olive Green with U.S. Medical Print (4059)':'',
    'Orange':'#FFA500',
    'Orange Crush':'',
    'Orange Glow':'',
    'Oxide Red':'#8A3324',
    'Oxide Red (Matte)':'',
    'Pale Oak Pearl White':'#F7F4EA',
    'Pearl Neckless White':'#F5F5F5',
    'Peat Moss':'',
    'Phantom':'#1F1F1F',
    'Pink':'#FFC0CB',
    'Pinup Red':'',
    'Pitch Black':'#0A0A0A',
    'Plaid Cabin Brown (4108)':'',
    'Plaid Cabin Brown (5000BN)':'',
    'Plaid Emerald Green (4111)':'',
    'Plaid Moonstone [Grey/Blue] (4109)':'',
    'Plaid Royal Stewart (5000RS)':'',
    'Plaid Royal Stewart (5002)':'',
    'Plaid Sky Blue (4110)':'',
    'Plaid Sky Blue (5000SB)':'',
    'Plaid Twilight [Blue/Grey] (4060)':'',
    'Plaid Twilight [Blue/Grey] (5000BG)':'',
    'Platinum Frost Pearl Metallic':'#E5E4E2',
    'Pontiac Light Blue':'',
    'Pontiac Metallic Blue':'',
    'Porsche Gray':'',
    'Premium Swiss Army Reproduction (4571)':'',
    'Primer Gray':'',
    'Pro Street Red':'',
    'Prym1 MP':'',
    'Pure White':'',
    'Purple':'#800080',
    'Purple Reign':'#800080',
    'RGB ColorSHIFT®':'',
    'Race Hemi Orange':'',
    'Rally Red':'',
    'Ranger Green':'',
    'Red':'#FF0000',
    'Red + Blue':'',
    'Red Halo':'#FF6961',
    'Red Marl':'#8B0000',
    'Red/Black':'#BA0000',
    'Regular Red':'#FF0000',
    'Rocket Red':'',
    'Royal Blue':'#4169E1',
    'Royal Blue (4685)':'#4169E1',
    'Rust':'#B7410E',
    'Safety Blue':'#0054B4',
    'Safety Blue (Gloss)':'',
    'Safety Green':'#00FF00',
    'Safety Green (Gloss)':'',
    'Safety Orange':'#FF6600',
    'Safety Red':'#FF0000',
    'Safety Yellow':'#EED202',
    'Safety Yellow (Gloss)':'',
    'Sage Green (4795)':'#9CBA7F',
    'Salmon':'#FA8072',
    'Sand':'#C2B280',
    'Satin':'',
    'Satin Black':'#2F2F2F',
    'Satin Finish':'',
    'School Bus Yellow':'#FFD800',
    'Shade of Gray':'',
    'Silt':'#879099',
    'Silver':'#808080',
    'Silver (Gloss)':'',
    'Silver Metallic':'#C0C0C0',
    'Silver Metallic - Satin':'',
    'Slate':'#31373B',
    'Slate Gray':'#708090',
    'Slate/Navy':'',
    'Smoke Blue':'#748B97',
    'Smoke Grey':'',
    'Solid Black':'#0D0D0D',
    'Solid Orange':'#FFA500',
    'Spruce Green Metallic':'#0A481E',
    'Stainless':'#808080',
    'Stainless Steel':'#808080',
    'Stealth Black':'',
    'Stone':'#928E85',
    'Street Hemi Orange':'',
    'Sub Zero Blue Pearl':'#B4D2E2',
    'Sublime Green':'',
    'Sugar Coat It Gold':'',
    'T-Bird Red':'',
    'Tan':'#775D33',
    'Tan/Black':'',
    'Tan_C':'#745B32',
    'Tangerine':'#F28500',
    'Teal':'#008080',
    'Torch Red':'#FF2400',
    'Tractor Yellow':'#F7C148',
    'Tropical Sunset Orange Pearl':'#FF4500',
    'U.S. Navy White w/Blue Stripe (4058)':'',
    'U/V Purple':'#800080',
    'USA Bright White':'',
    'UV/Purple':'#800080',
    'UV/Purple Halo':'#800080',
    'Ultrasonic Blue':'',
    'Universal Aluminum':'#A8A9AD',
    'Universal Cast Iron Gray':'',
    'Universal Gloss Black':'',
    'Universal Red':'',
    'Veil Canyon Grey':'#6F6A5A',
    'Veil Canyon Hybrid':'',
    'Velvet Black':'#1A1A1A',
    'Vino Rojo':'',
    'Warm White':'',
    'White':'#FFFFFF',
    'White (Flat)':'',
    'White (Gloss)':'',
    'White + Amber':'',
    'White Halo':'#FFFFFF',
    'White-Black Marble':'',
    'Wimbledon White':'',
    'Wine':'#722F37',
    'Yellow':'#FFFF00',
    'Yellow/Gray':'#CCCC33',
    '[S]Color':'',
    'khaki':'#F0E68C',
}


export const trendingSearches = [
    {
        name: "Lisle",
        url: "/shop?search_query=lisle"  
    },
    {
        name: "Meguiars",
        url: "/shop?search_query=Meguiars"
    },
    {
        name: "Astro",
        url: "/shop?search_query=Astro"  
    },
    {
        name: "Streamlight",
        url: "/shop?search_query=Streamlight"  
    },
    {
        name: "Wheel Weight",
        url: "/shop?search_query=Wheel+Weight"  
    },
    {
        name: "crimping pliers",
        url: "/shop?search_query=crimping+pliers"  
    },
    {
        name: "Milwaukee",
        url: "/shop?search_query=Milwaukee"  
    }
]

export const trendingCollections = [
    {
        name: "3M",
        url: "/brands/3M"
    },
    {
        name: "Access Tools",
        url: "/brands/Access-Tools"
    },
    {
        name: "Antigravity Batteries",
        url: "/brands/Antigravity-Batteries.html"
    },
    {
        name: "Dewalt",
        url: "/brands/Dewalt"
    },
]

export const transformSavingsAndOffersFacetData = (data) => {
    return data.filter(item => item.value === "Specials & Clearance" || item.value === "Specials & Clearance/Tool Specials")
};

export const transformCategoriesFacetData = (data) => {
    return data.filter(item => item.value !== "Specials & Clearance" && item.value !== "Specials & Clearance/Tool Specials")
};

export const clearanceCategoriesArr = ['2703', '3156', '3167', '3169', '3166', '3165', '3657', '3168'];

// graphQL

// const storefrontHostname = 'jb-sandbox-s6.mybigcommerce.com';
// const storefrontToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjaWQiOlsxXSwiY29ycyI6WyJodHRwczovL2RldmVsb3Blci5iaWdjb21tZXJjZS5jb20iXSwiZWF0IjoxNzQ5OTc0NTYyLCJpYXQiOjE3NDk4MDE3NjIsImlzcyI6IkJDIiwic2lkIjoxMDAyNDM5OTMyLCJzdWIiOiJCQyIsInN1Yl90eXBlIjowLCJ0b2tlbl90eXBlIjoxfQ.YNMLXfNs3GqoRXD9a-Q17jNyZTvHfzgSUwTuipMlmD6A-ew8C19rw5MtRk43Ndx8sVWJRvORHoX92Ni-GsusdA'; // Replace with your actual storefront token

// const graphqlEndpoint = `https://${storefrontHostname}/graphql`;

// const query = `
//   query ExtendedProductsById($productIds: [Int!]) {
//     site {
//       products(entityIds: $productIds, first: 5) {
//         edges {
//           node {
//             name
//             variants(first: 25) {
//               edges {
//                 node {
//                   sku
//                   defaultImage {
//                     url(width: 1000)
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `;

// const variables = {
//   productIds: [126]
// };

// const headers = {
//   'Content-Type': 'application/json',
//   'Authorization': `Bearer ${storefrontToken}`
// };

// fetch(graphqlEndpoint, {
//   method: 'POST',
//   headers: headers,
//   body: JSON.stringify({
//     query: query,
//     variables: variables
//   })
// })
// .then(response => {
//   if (!response.ok) {
//     return response.text().then(text => {
//       console.error('Response error text:', text);
//       throw new Error('Network response was not ok');
//     });
//   }
//   return response.json();
// })
// .then(data => {
//   console.log('Fetched data:', data);
// })
// .catch(error => {
//   console.error('Fetch operation error:', error);
// });

// default fetch 

// const storeHash = '2h9e5ps1qa'; 
// const productId = 126;
// const authToken = 'pj9b2lbhda92b19ssb2dogyyrxmkej';

// const url = `https://api.bigcommerce.com/stores/${storeHash}/v3/catalog/products/${productId}/variants`;

// const headers = {
//   'X-Auth-Token': authToken,
//   'Accept': 'application/json',
//   'Content-Type': 'application/json'
// };

// fetch(url, {
//   method: 'GET',
//   headers: headers
// })
// .then(response => {
//   if (!response.ok) {
//     return response.text().then(text => {
//       console.error('Response error text:', text);
//       throw new Error('Network response was not ok');
//     });
//   }
//   return response.json();
// })
// .then(data => {
//   console.log('Product variants fetched successfully:', data);
// })
// .catch(error => {
//   console.error('Error fetching product variants:', error);
// });

// create token 

// const storeHash = '2h9e5ps1qa';
// const authToken = 'pj9b2lbhda92b19ssb2dogyyrxmkej';

// const url = `https://api.bigcommerce.com/stores/${storeHash}/v3/storefront/api-token`;

// const headers = {
//   'X-Auth-Token': authToken,
//   'Accept': 'application/json',
//   'Content-Type': 'application/json'
// };

// const body = {
//   allowed_cors_origins: ["https://www.nosto.com/", "https://jb-sandbox-s6.mybigcommerce.com"],
//   channel_id: 1
// };

// fetch(url, {
//   method: 'POST', 
//   mode: 'cors',
//   headers: headers,
//   body: JSON.stringify(body)
// })
// .then(response => {
//   if (!response.ok) {
//     return response.text().then(text => {
//       console.error('Response error text:', text);
//       throw new Error('Network response was not ok');
//     });
//   }
//   return response.json();
// })
// .then(data => {
//   console.log('Storefront API Token created successfully:', data);
// })
// .catch(error => {
//   console.error('Error creating Storefront API Token:', error);
// });

export async function waitForAttribute(selector, attribute, expectedValue, maxRetries, retryInterval, currentRetry = 0) {
    const element = document.querySelector(selector);
    if (element && element.getAttribute(attribute) === expectedValue) {
        console.log(`Attribute "${attribute}" is as expected: "${expectedValue}"`);
        return;
    }

    if (currentRetry >= maxRetries) {
        console.error(`Max retries (${maxRetries}) reached. Attribute "${attribute}" is not as expected.`);
        return;
    }

    console.log(`Attribute "${attribute}" not found or not as expected. Retrying... (${currentRetry + 1}/${maxRetries})`);
    await new Promise(resolve => setTimeout(resolve, retryInterval));
    await waitForAttribute(selector, attribute, expectedValue, maxRetries, retryInterval, currentRetry + 1);
}

// export async function waitForText(selector, expectedText, maxRetries, retryInterval, currentRetry = 0) {
//     const element = document.querySelector(selector);
//     if (element && element.textContent.trim() === expectedText) {
//         console.log(`Text content is as expected: "${expectedText}"`);
//         return;
//     }
//     if (currentRetry >= maxRetries) {
//         console.error(`Max retries (${maxRetries}) reached. Text content is not as expected.`);
//         return;
//     }
//     console.log(`Text content not found or not as expected. Retrying... (${currentRetry + 1}/${maxRetries})`);
//     await new Promise(resolve => setTimeout(resolve, retryInterval));
//     await waitForText(selector, expectedText, maxRetries, retryInterval, currentRetry + 1);
// }


export function isUsaFromDOM() {
    const htmlElement = document.documentElement;
    const lang = htmlElement.getAttribute('lang');
    // console.log('isUsa', lang === "en");
    return lang === "en";
}